/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BrandsResponseWithPaginationDto } from '../models';
/**
 * BrandApi - axios parameter creator
 * @export
 */
export const BrandApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение брендов по фильтру
         * @param {number} [id] ID конкретного бренда
         * @param {Array<number>} [ids] Массив ID брендов
         * @param {string} [query] Строка для поиска по названию или описанию
         * @param {number} [limit] Лимит для пагинации
         * @param {number} [cursor] Смещение для пагинации
         * @param {boolean} [hideEmpty] Скрыть бренды без продаваемых товаров (0 товаров в product_view)
         * @param {boolean} [withCount] Добавить productCount в каждый бренд
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandControllerGetBrands: async (id?: number, ids?: Array<number>, query?: string, limit?: number, cursor?: number, hideEmpty?: boolean, withCount?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }

            if (withCount !== undefined) {
                localVarQueryParameter['withCount'] = withCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandApi - functional programming interface
 * @export
 */
export const BrandApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение брендов по фильтру
         * @param {number} [id] ID конкретного бренда
         * @param {Array<number>} [ids] Массив ID брендов
         * @param {string} [query] Строка для поиска по названию или описанию
         * @param {number} [limit] Лимит для пагинации
         * @param {number} [cursor] Смещение для пагинации
         * @param {boolean} [hideEmpty] Скрыть бренды без продаваемых товаров (0 товаров в product_view)
         * @param {boolean} [withCount] Добавить productCount в каждый бренд
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandControllerGetBrands(id?: number, ids?: Array<number>, query?: string, limit?: number, cursor?: number, hideEmpty?: boolean, withCount?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandsResponseWithPaginationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandControllerGetBrands(id, ids, query, limit, cursor, hideEmpty, withCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.brandControllerGetBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandApi - factory interface
 * @export
 */
export const BrandApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение брендов по фильтру
         * @param {BrandApiBrandControllerGetBrandsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandControllerGetBrands(requestParameters: BrandApiBrandControllerGetBrandsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BrandsResponseWithPaginationDto> {
            return localVarFp.brandControllerGetBrands(requestParameters.id, requestParameters.ids, requestParameters.query, requestParameters.limit, requestParameters.cursor, requestParameters.hideEmpty, requestParameters.withCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for brandControllerGetBrands operation in BrandApi.
 * @export
 * @interface BrandApiBrandControllerGetBrandsRequest
 */
export interface BrandApiBrandControllerGetBrandsRequest {
    /**
     * ID конкретного бренда
     * @type {number}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly id?: number

    /**
     * Массив ID брендов
     * @type {Array<number>}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly ids?: Array<number>

    /**
     * Строка для поиска по названию или описанию
     * @type {string}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly query?: string

    /**
     * Лимит для пагинации
     * @type {number}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly limit?: number

    /**
     * Смещение для пагинации
     * @type {number}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly cursor?: number

    /**
     * Скрыть бренды без продаваемых товаров (0 товаров в product_view)
     * @type {boolean}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly hideEmpty?: boolean

    /**
     * Добавить productCount в каждый бренд
     * @type {boolean}
     * @memberof BrandApiBrandControllerGetBrands
     */
    readonly withCount?: boolean
}

/**
 * BrandApi - object-oriented interface
 * @export
 * @class BrandApi
 * @extends {BaseAPI}
 */
export class BrandApi extends BaseAPI {
    /**
     * 
     * @summary Получение брендов по фильтру
     * @param {BrandApiBrandControllerGetBrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public brandControllerGetBrands(requestParameters: BrandApiBrandControllerGetBrandsRequest = {}, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).brandControllerGetBrands(requestParameters.id, requestParameters.ids, requestParameters.query, requestParameters.limit, requestParameters.cursor, requestParameters.hideEmpty, requestParameters.withCount, options).then((request) => request(this.axios, this.basePath));
    }
}

